import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Organization } from '@app/org-frontend';
/**
 * Resolve org permission name label from it's related db organization
 * @param orgPermissionId The id of the org permission to resolve its name from
 */
export const orgPermissionNameResolver = (orgPermissionId) => {
    const dbOrg = ModuleFE_Organization.cache.unique(orgPermissionId);
    if (!dbOrg)
        throw new MUSTNeverHappenException(`cannot find db organization with the id ${orgPermissionId}`);
    return dbOrg.alias ?? dbOrg.name;
};
//# sourceMappingURL=utils.js.map